var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-0",attrs:{"small":"","icon":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("mdi-chevron-left")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }